/**
 * API errors and their messages, apart from the client so pages that never sign in (the public marketing pages) can
 * use them without loading supabase-js.
 */

/** An API error as the server reports it: `{ error, message, issues? }`. Messages are safe to show. */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly issues: Array<{ path: string; message: string }> = [],
    readonly details: Record<string, unknown> = {},
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/** A human message for any thrown error. */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.issues.length) return `${err.message}: ${err.issues.map((i) => (i.path ? `${i.path} ${i.message}` : i.message)).join('; ')}`;
    return err.message;
  }
  if (err instanceof Error) return err.message;
  return 'Something went wrong.';
}
